Object.defineProperty(exports,"__esModule",{value:true});exports.healthPriority=exports.worsedHealthStatus=exports.createHealthStatus=exports.HealthStatus=exports.HealthStateValue=undefined;

var _health_state_pb=require('../protoModels/mti/health_state_pb');exports.


HealthStateValue=_health_state_pb.HealthStatus;


var HealthStatus=exports.HealthStatus={
HEALTHY:'HEALTHY',
UNHEALTHY:'UNHEALTHY',
WARNING:'WARNING',
UNKNOWN:'UNKNOWN',
MISSING_SECURITY_DEVICE:'MISSING_SECURITY_DEVICE'};





















var createHealthStatus=exports.createHealthStatus=function createHealthStatus(
rawStatus,
message,
action,
since)
{
switch(rawStatus){
case _health_state_pb.HealthStatus.HEALTHY:
return{
type:HealthStatus.HEALTHY,
payload:{
message:message,
action:action,
since:since}};


case _health_state_pb.HealthStatus.UNHEALTHY:
return{
type:HealthStatus.UNHEALTHY,
payload:{
message:message,
action:action,
since:since}};


case _health_state_pb.HealthStatus.HEALTH_WARNING:
return{
type:HealthStatus.WARNING,
payload:{
message:message,
action:action,
since:since}};


default:
return{
type:HealthStatus.UNKNOWN};}


};





var worsedHealthStatus=exports.worsedHealthStatus=function worsedHealthStatus(
statuses)
{
var worsed=statuses.reduce(function(worsedSoFar,currentStatus){
var worsedSoFarPriority=healthPriority(worsedSoFar);
var currentStatusPriority=healthPriority(currentStatus);

return worsedSoFarPriority<currentStatusPriority?
worsedSoFar:
currentStatus;
},statuses[0]);

return worsed;
};

var healthPriority=exports.healthPriority=function healthPriority(status){
switch(status.type){
case HealthStatus.HEALTHY:
return 5;
case HealthStatus.MISSING_SECURITY_DEVICE:
return 4;
case HealthStatus.WARNING:
return 3;
case HealthStatus.UNHEALTHY:
return 2;
case HealthStatus.UNKNOWN:
return 1;
default:
return 0;}

};